import { call, put, all, takeEvery, takeLeading } from 'redux-saga/effects'
import { openModal, openModalWithArg, openSnackbar } from 'reducers/messageReducer';
import {
  iumpInit,
  setIumpInitResult,
  historyConfirm,
  iumpInsert,
  setConfirmAgainFlg,
  setUploadResultInfo,
  setsackbarOpenFlg
} from 'reducers/selectionFileUploadIumpReducer'
import {
  initApi,
  historyConfirmApi,
  insertApi
} from 'apis/MCBPS030Api'
import { magiContants } from 'utils/contants';
import { routeList } from 'routes/routes'
import history from 'utils/history'

function* iumpInitSaga(action: ReturnType<typeof iumpInit>) {
  try {
    const data = yield call(initApi);
    yield put(setIumpInitResult(data))
  } catch (error) {
    yield put(openModal(error.message))
  }
}

function* historyConfirmSaga(action: ReturnType<typeof historyConfirm>) {
  try {
    const data = yield call(historyConfirmApi);
    if (data == 'Successed') {
      history.push(routeList.selectionFileUploadHistory)
    }
  } catch (error) {
    yield put(openModal(error.message))
  }
}

function* iumpInsertSaga(action: ReturnType<typeof iumpInsert>) {
  try {
    const data = yield call(insertApi, action.payload);
    const messageId = data.endMessageId
    if (messageId === magiContants.MESSAGECODE_MCBPS030_006) {
      const messages = data.messages
      const [...args] = messages
      yield put(openModalWithArg({messageId, args}))
    } else if (messageId === magiContants.MESSAGECODE_MCBPS030_014) {
      yield put(setConfirmAgainFlg(false))
      yield put(setsackbarOpenFlg(true))
    } else {
      yield put(setConfirmAgainFlg(true))
      yield put(setUploadResultInfo(data))
    }
  } catch (error) {
    yield put(openModal(error.message))
  }
}

export default function* selectionFileUploadIumpSaga() {
  yield all([
    takeEvery(iumpInit, iumpInitSaga),
    takeEvery(historyConfirm, historyConfirmSaga),
    takeLeading(iumpInsert, iumpInsertSaga),
  ])
}